import React from 'react'

export default function WebSquare7() {
  return (
    <div className='websquare7'>
        <div className="websquare7__top">
            <p>۱۰۰۰ +</p>
        </div>
        <div className="websquare7__text">
        پروژه
        </div>
    </div>
  )
}
